var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 24,
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2039_351)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H32V12H0V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 12H32V24H0V12Z",
    fill: "#D7141A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6 12L0 0V24L17.6 12Z",
    fill: "#11457E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2039_351"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 24,
    rx: 4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCz);
export default __webpack_public_path__ + "static/media/cz.d175255c1425d7e78ef1084b44a993b4.svg";
export { ForwardRef as ReactComponent };